import { render, staticRenderFns } from "./InsuranceProjectManagement.vue?vue&type=template&id=323dd4e1&scoped=true"
import script from "./InsuranceProjectManagement.vue?vue&type=script&lang=js"
export * from "./InsuranceProjectManagement.vue?vue&type=script&lang=js"
import style0 from "./InsuranceProjectManagement.vue?vue&type=style&index=0&id=323dd4e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323dd4e1",
  null
  
)

export default component.exports